exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-email-form[data-v-c360596c] {\n  margin-top: 20px;\n}\n.h-attach-error[data-v-c360596c] {\n  font-size: 12px;\n  margin-left: 10px;\n}\n.button-info[data-v-c360596c] {\n  color: #6e6e6e;\n}\n@media screen and (min-width: 320px) and (max-width: 480px) {\n.h-email-form[data-v-c360596c] {\n    margin-top: 40px;\n}\n#cw-body .h-email-caption[data-v-c360596c] {\n    margin: 0 0 35px;\n    text-align: center;\n    font-family: Roboto, sans-serif;\n    color: #000;\n}\n}\n", ""]);

// exports
